import { useEffect, useMemo, useState } from "react";
import { LightBox } from "../../../LightBox/LightBox";
import { GetThumbnail } from "../../funcs";
import { PopupSideBarImage } from "../../PopupSidebarImage";
import "./PopupToolkit.scss";

export const PopupToolkit = (props) => {
  console.log("PopupToolkit props", props);
  return (
    <div className="c-detail-fiche__body">
      <div className="practical">
        <div className="left">
          <div className="inner">
            <div className="bottom">
              <PopupToolkitSideBar
                dictionary={props.dictionary}
                data={props.data}
                blockListBodyContentHandler={props.blockListBodyContentHandler}
              />
            </div>
          </div>
        </div>
        <div className="right">
          <PopupToolkitBody
            dictionary={props.dictionary}
            blockListBodyContentHandler={props.blockListBodyContentHandler}
            data={props.data}
          />
        </div>
      </div>
    </div>
  );
};

const PopupToolkitSideBar = (props) => {
  const [lightboxThumbnailUrl, setLightboxThumbnailUrl] = useState("");

  useEffect(() => {
    (async () => {
      if (
        props.data.detailSideBar &&
        props.data.detailSideBar.videos &&
        props.data.detailSideBar.videos.length > 0 &&
        props.data.detailSideBar.videos[0].url
      ) {
        var thumbnail = await GetThumbnail(
          props.data.detailSideBar.videos[0].url
        );
        setLightboxThumbnailUrl(thumbnail);
      }
    })();
  }, [JSON.stringify(props.data.detailSideBar.videos)]);

  const sideBarImages = useMemo(() => {
    if (
      props.data.detailSideBar &&
      props.data.detailSideBar.images &&
      props.data.detailSideBar.images.length > 0
    ) {
      return props.data.detailSideBar.images.map(
        (image) =>
          image?.url && <PopupSideBarImage src={image.url} alt={image.alt} />
      );
    }
  }, [JSON.stringify(props.data.detailSideBar?.images)]);

  const sideBarItems = useMemo(() => {
    if (props.data.detailSideBar && props.data.detailSideBar.content) {
      return props.data.detailSideBar.content.map((item) => (
        <div className="item">
          {item.url ? (
            <div>
              <a href={item.url} target={item.target ? item.target : ""}>
                <i className={item.icon}></i> {item.text}
              </a>
            </div>
          ) : (
            <div>
              <i className={item.icon}></i> {item.text}
            </div>
          )}
        </div>
      ));
    }
  }, [JSON.stringify(props.data.detailSideBar)]);

  return (
    props.data.detailSideBar && (
      <div className="bottom">
        {props.data.detailSideBar.startDate && (
          <div className="info">
            {props.data.detailSideBar.startDate}
            {props.data.detailSideBar.endDate &&
              ` - ${props.data.detailSideBar.endDate}`}
          </div>
        )}

        <div className="icon-items">{sideBarItems}</div>
        <div className="media-fiche">{sideBarImages}</div>
        {props.data?.detailSideBar?.videos &&
          props.data?.detailSideBar?.videos.length > 0 && (
            <LightBox
              thumbnail={lightboxThumbnailUrl}
              slides={props.data.detailSideBar.videos}
            />
          )}
      </div>
    )
  );
};

const PopupToolkitBody = (props) => {
  const [lightboxThumbnailUrl, setLightboxThumbnailUrl] = useState("");

  useEffect(() => {
    (async () => {
      if (
        props.data.detailBody &&
        props.data.detailBody.videos &&
        props.data.detailBody.videos.length > 0 &&
        props.data.detailBody.videos[0].url
      ) {
        var thumbnail = await GetThumbnail(props.data.detailBody.videos[0].url);
        setLightboxThumbnailUrl(thumbnail);
      }
    })();
  }, [JSON.stringify(props.data.detailBody.videos)]);

  return (
    <div className="inner">
      <div className="bottom">
        {props.data.detailBody && (
          <div
            dangerouslySetInnerHTML={{ __html: props.data.detailBody.content }}
          ></div>
        )}
        {props.data?.detailBody?.videos.length > 0 && (
          <div className="videos">
            <LightBox
              thumbnail={lightboxThumbnailUrl}
              slides={props.data.detailBody.videos}
            />
          </div>
        )}
        <div className="download">
          {props.data.detailBody && props.data.detailBody.button && (
            <a
              href={props.data.detailBody.button.url}
              className="c-button c-button--block"
              target={props.data.detailBody.button.target}
            >
              {props.data.detailBody.button.title}{" "}
              <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
